export const chatblkConfig = {
	// Get domain configuration
	getDomainConfig: function () {
		const domain = window.location.origin;
		const config = {
			issuer: '',
		};

		if (domain.includes('chatblkdev')) {
			config.issuer = 'https://test-connect.blackrock.com';
		} else if (domain.includes('chatblktst')) {
			config.issuer = 'https://test-connect.blackrock.com';
		} else if (domain.includes('preview')) {
			config.issuer = 'https://connect.blackrock.com';
		} else {
			config.issuer = 'https://test-connect.blackrock.com';
		}

		// Store the issuer in localStorage
		const existingConfig = JSON.parse(
			localStorage.getItem('chatblk_config') || '{}'
		);
		existingConfig.chatblk_issuer = config.issuer;
		localStorage.setItem('chatblk_config', JSON.stringify(existingConfig));

		return config;
	},

	// Get login page URL based on current domain
	getLoginPageUrl: function () {
		const domain = window.location.origin;
		const loginPage =
			domain.includes('preview') || domain.includes('testc')
				? `${domain}/us/financial-professionals/advisorcenter-login`
				: `${domain}/financial-professionals/financial-professionals/advisorcenter-login`;

		// Store the login page URL in localStorage
		const existingConfig = JSON.parse(
			localStorage.getItem('chatblk_config') || '{}'
		);
		existingConfig.chatblk_signin_url = loginPage;
		localStorage.setItem('chatblk_config', JSON.stringify(existingConfig));

		return loginPage;
	},
};
